export const formatPhoneNumber = (str) => {
      if (str) {
        let result = `+${str.slice(0, 3)} ${str.slice(3, 5)} ${str.slice(
          5,
          8
        )}-${str.slice(8, 10)}-${str.slice(10, 12)}`;
    
        return result;
      } else {
        return "";
      }
    };
    